(function () {'use strict';}());

angular.module('app')
.config( [
   '$compileProvider',
   function( $compileProvider )
   {   
       $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|sms):/);
       // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
   }
])
  .controller('AppController', function ($scope,$timeout,$window,AppService) {
  	var trace = angular.trace;

  	$scope.PAGE_LANDING = 0;
    $scope.PAGE_MENU =  1;
  	$scope.PAGE_ASSESSMENT = 2;
  	$scope.PAGE_REFLECTION = 3;
  	$scope.PAGE_SHARE = 4;
  	$scope.PAGE_RESOURCES = 5;
    $scope.PAGE_CONTACT = 6;
    $scope.PAGE_CONTACTPRE = 7;
    $scope.PAGE_ACHIEVEMENTS = 8;

    $scope.TRANSITION_SPEED = 250;


    $scope.containerClasses = {rendered:false,saving:false,modalView:false, showLoader: false};
    $scope.customClasses = {};
  	$scope.currentPageIndex = $scope.PAGE_LANDING;
    $scope.questions = null;
    $scope.selectedMessageType = null;
    $scope.selectedMessage = null;
    $scope.deviceType = navigator.userAgent.match(/android/i) ? "android" : "iphone";
    $scope.deviceDelimiter = $scope.deviceType === "android" ? "?":"&";
    $scope.messageTemplate = null;
    $scope.selectedContact = null;
    $scope.selectedMessage = null;

/*
    $window.addEventListener('popstate',function(){
      var currentPage = getPageLabel($scope.currentPageIndex);
      var currentHash = $window.location.hash.replace(/#/gim,"");
      if(!currentHash || currentHash === currentPage) return;
      $scope.$apply(function(){ $scope.currentPageIndex = $scope[currentHash];});
    });*/


    function getPageLabel(index){
      switch(index)
      {
        case 0: return "PAGE_LANDING";
        case 1: return "PAGE_MENU";
        case 2: return "PAGE_ASSESSMENT";
        case 3: return "PAGE_REFLECTION";
        case 4: return "PAGE_SHARE";
        case 5: return "PAGE_RESOURCES";
        case 6: return "PAGE_CONTACT";
        case 7: return "PAGE_CONTACTPRE";
        case 8: return "PAGE_ACHIEVEMENTS";
        default: return null;
      }
    }

    $scope.$watch("selectedContact",onContactInfoChange);
    $scope.$watch("selectedMessage",onContactInfoChange);

    $scope.clearContactInfo = function(){
      $scope.messageTemplate = null;
      $scope.selectedContact = null;
      $scope.selectedMessage = null;
    };

    function onContactInfoChange()
    {
      if(!$scope.selectedContact) return;
      $scope.messageTemplate = cleanupPhone($scope.selectedContact.phone) + ($scope.selectedMessage ? ($scope.deviceDelimiter + "body=" + $scope.selectedMessage): "");
    }

    function cleanupPhone(phone)
    {
      if(phone) return phone.replace(/[+ \-]/gim,"");
    }

    $scope.selectFunctionMessage = function(message){
      $scope.selectedMessage = message;
    };

    $scope.logout = function() {
      AppService.logout();
    };

    $scope.prevent = function(event){
      if (!$scope.selectedContact){
        event.preventDefault();
        alert("Please select a recipient from the menu.");
      }
    };

    $scope.launchApp = function(){
      $scope.containerClasses.saving = true;
      return AppService.loadAppContent().then(initialize);
    };

    $scope.setCurrentPage = function(value){
      if($scope.currentPageIndex === value) return;

    	$scope.requestedPage = value;
      $scope.containerClasses.transitioning = true;
      $timeout(changePage, 250);
    };

    function changePage() {
      $scope.currentPageIndex = $scope.requestedPage;
      $window.location.hash = getPageLabel($scope.requestedPage);
      $scope.containerClasses.transitioning = false;
      $scope.requestedPage = null;

      for(var prop in $scope.customClasses) {
        delete $scope.customClasses[prop];
      }

    }

    $scope.setCurrentAssessment = function(value,isWeek){

      if(isWeek === true){
        value = AppService.getIdForWeek(value);
      }
      $scope.currentAssessmentID = value;
      AppService.updateAssessmentData(value);
      $scope.questions = AppService.assessmentData.questions;
      $scope.$broadcast("assessmentChange",{questions:$scope.questions});
    };


    $scope.getPagePosition = function(value){
      if(value > $scope.currentPageIndex) return "right";
      if(value < $scope.currentPageIndex) return "left";
      return "center";
    };

    $scope.getCurrentPageName = function() {
      for(var prop in $scope) {
        if(!prop.match(/^PAGE_/)) continue;
        if($scope[prop] !== $scope.currentPageIndex) continue;
        return prop.replace(/^PAGE_/gim,"").toLowerCase();
      }
      return null;
    };

    $scope.getCurrentClasses = function() {
      var pagename = $scope.getCurrentPageName();
      var output = [pagename];

      for(var prop in $scope.customClasses) {
        var value = $scope.customClasses[prop];
        if(!value) continue;
        output.push(prop);
      }

      return output;
    };

    $scope.updateBadges = function() {
      $scope.badges = AppService.badges;
    };

    $scope.launchApp();

    function initialize(result){
      if(!result.data.authenticated) {
        $timeout(function(){$scope.containerClasses.rendered = true; $scope.containerClasses.saving = false;},1000);
        return;
      }

      $scope.currentAssessmentID = result.data.assessmentResults.current;
      $scope.questions = result.data.assessment.questions;
      $scope.setCurrentPage($scope.PAGE_MENU);
      $timeout(function(){$scope.containerClasses.rendered = true;},1000);
      $scope.contacts = AppService.contacts;
      $scope.messages = AppService.messages;
      $scope.badges = AppService.badges;
      $scope.containerClasses.saving = false;
    }

    $scope.setHomePage = function(){
        $scope.setCurrentPage($scope.PAGE_MENU);
    };

  });




